export const APP_NAME = 'buscador-facturas';
